var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcContent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1902 86.066L22.6459 87.5218L24.1062 86.062L24.7302 86.6858L23.2696 88.1454L24.7262 89.6011L24.1005 90.2266L22.6438 88.7711L21.1845 90.2306L20.5605 89.6068L22.0201 88.1475L20.5645 86.6915L21.1902 86.066Z",
    fill: "#919EAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.2381 12.7676L88.6937 14.2234L90.1541 12.7635L90.7781 13.3874L89.3175 14.8469L90.7741 16.3026L90.1483 16.9282L88.6916 15.4726L87.2323 16.9322L86.6083 16.3084L88.0679 14.8491L86.6124 13.3931L87.2381 12.7676Z",
    fill: "#919EAB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.6978 39.0406L95.6585 40.0797L95.6571 40.081C95.6368 40.1012 95.6207 40.1252 95.6097 40.1517C95.5987 40.1781 95.593 40.2064 95.593 40.235C95.593 40.2637 95.5987 40.292 95.6097 40.3184C95.6207 40.3449 95.6368 40.3689 95.6571 40.3891L95.6585 40.3904L96.6978 41.4295C96.739 41.4704 96.7948 41.4936 96.8529 41.4936C96.911 41.4936 96.9667 41.4706 97.0078 41.4297L98.0487 40.3891C98.069 40.3689 98.0851 40.3449 98.0961 40.3184C98.1072 40.2919 98.1128 40.2636 98.1128 40.235C98.1128 40.2065 98.1072 40.1782 98.0961 40.1517C98.0851 40.1252 98.069 40.1012 98.0487 40.081L98.0473 40.0797L97.008 39.0406C96.9669 38.9997 96.911 38.9765 96.8529 38.9765C96.7948 38.9765 96.739 38.9997 96.6978 39.0406ZM94.7813 39.2011L95.8211 38.1616C96.095 37.8885 96.466 37.735 96.8529 37.735C97.2397 37.735 97.6108 37.8885 97.8847 38.1616L98.9237 39.2004L98.9244 39.2011C99.0606 39.3365 99.1686 39.4975 99.2423 39.6747C99.3162 39.8522 99.3543 40.0426 99.3543 40.235C99.3543 40.4274 99.3162 40.6179 99.2423 40.7954C99.1686 40.9726 99.0606 41.1335 98.9245 41.269L98.9237 41.2697L97.8847 42.3085C97.6108 42.5816 97.2397 42.735 96.8529 42.735C96.466 42.735 96.095 42.5816 95.8211 42.3085L94.7821 41.2697L94.7813 41.2689C94.6452 41.1335 94.5372 40.9726 94.4635 40.7954C94.3896 40.6178 94.3516 40.4273 94.3516 40.235C94.3516 40.0427 94.3896 39.8523 94.4635 39.6747C94.5372 39.4975 94.6452 39.3366 94.7813 39.2011Z",
    fill: "#919EAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.355 105.714L61.3157 106.753L61.3143 106.755C61.294 106.775 61.2779 106.799 61.2669 106.825C61.2559 106.852 61.2503 106.88 61.2503 106.909C61.2503 106.937 61.2559 106.966 61.2669 106.992C61.2779 107.019 61.294 107.043 61.3143 107.063L61.3157 107.064L62.355 108.103C62.3962 108.144 62.4521 108.167 62.5101 108.167C62.5682 108.167 62.6239 108.144 62.665 108.103L63.7059 107.063C63.7262 107.043 63.7423 107.019 63.7534 106.992C63.7644 106.966 63.77 106.937 63.77 106.909C63.77 106.88 63.7644 106.852 63.7534 106.825C63.7423 106.799 63.7262 106.775 63.7059 106.755L63.7046 106.753L62.6653 105.714C62.6241 105.673 62.5682 105.65 62.5101 105.65C62.4521 105.65 62.3962 105.673 62.355 105.714ZM60.4385 105.875L61.4784 104.835C61.7522 104.562 62.1233 104.409 62.5101 104.409C62.897 104.409 63.268 104.562 63.5419 104.835L64.581 105.874L64.5817 105.875C64.7178 106.01 64.8258 106.171 64.8995 106.348C64.9734 106.526 65.0115 106.716 65.0115 106.909C65.0115 107.101 64.9734 107.291 64.8995 107.469C64.8258 107.646 64.7178 107.807 64.5817 107.943L64.581 107.943L63.5419 108.982C63.268 109.255 62.897 109.409 62.5101 109.409C62.1233 109.409 61.7522 109.255 61.4784 108.982L60.4393 107.943L60.4385 107.943C60.3024 107.807 60.1944 107.646 60.1207 107.469C60.0468 107.291 60.0088 107.101 60.0088 106.909C60.0088 106.716 60.0468 106.526 60.1207 106.348C60.1945 106.171 60.3024 106.01 60.4385 105.875Z",
    fill: "#919EAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.552 66.3174C104.701 66.2789 104.858 66.278 105.008 66.3153C105.173 66.3561 105.322 66.4409 105.442 66.5601C105.561 66.6797 105.646 66.8295 105.687 66.9935C105.724 67.1437 105.723 67.3005 105.685 67.4497L105.109 70.5411C105.062 70.7839 104.909 71.1334 104.522 71.2523C104.135 71.3714 103.812 71.1678 103.638 70.9932L101.009 68.3653C100.831 68.1888 100.628 67.8651 100.748 67.4773C100.868 67.0899 101.219 66.9375 101.464 66.8922C101.465 66.8921 101.465 66.8921 101.465 66.892L104.552 66.3174ZM104.448 67.5539L102.291 67.9554L104.046 69.7099L104.448 67.5539Z",
    fill: "#919EAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.46 94.266C102.609 94.2275 102.766 94.2266 102.916 94.2639C103.08 94.3047 103.23 94.3895 103.349 94.5088C103.469 94.6283 103.554 94.7781 103.594 94.9421C103.632 95.0923 103.631 95.2491 103.592 95.3983L103.016 98.4897C102.97 98.7325 102.817 99.082 102.43 99.201C102.042 99.32 101.72 99.1164 101.545 98.9419L98.9167 96.3139C98.7386 96.1374 98.5356 95.8137 98.6558 95.426C98.776 95.0385 99.1263 94.8861 99.3721 94.8408C99.3724 94.8408 99.3727 94.8407 99.373 94.8407L102.46 94.266ZM102.356 95.5026L100.199 95.904L101.954 97.6586L102.356 95.5026Z",
    fill: "#919EAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5004 72.4729C12.3186 72.4729 12.1408 72.5269 11.9896 72.6279C11.8383 72.729 11.7205 72.8724 11.651 73.0402C11.5814 73.2081 11.5632 73.393 11.5987 73.5712C11.6341 73.7494 11.7217 73.9132 11.8502 74.0417C11.9787 74.1702 12.1425 74.2577 12.321 74.2932C12.4996 74.3287 12.6845 74.3105 12.8523 74.241C13.0203 74.1715 13.1639 74.0536 13.265 73.9024C13.366 73.7513 13.4199 73.5736 13.4199 73.3919C13.4199 73.1482 13.323 72.9145 13.1506 72.7421C12.9783 72.5698 12.7444 72.4729 12.5004 72.4729ZM11.1113 71.3132C11.5225 71.0386 12.0059 70.8919 12.5004 70.8919C13.1635 70.8919 13.7995 71.1552 14.2684 71.624C14.7374 72.0929 15.0009 72.7288 15.0009 73.3919C15.0009 73.8864 14.8542 74.3698 14.5794 74.7809C14.3047 75.1919 13.9142 75.5125 13.4572 75.7017C13.0002 75.891 12.4975 75.9403 12.0127 75.8438C11.5278 75.7474 11.0822 75.5095 10.7324 75.1598C10.3827 74.8102 10.1446 74.3647 10.0481 73.8797C9.95156 73.3947 10.0011 72.8919 10.1904 72.4351C10.3797 71.9782 10.7002 71.5878 11.1113 71.3132Z",
    fill: "#919EAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5424 18.4018C54.3606 18.4018 54.1828 18.4557 54.0316 18.5567C53.8803 18.6578 53.7625 18.8013 53.693 18.9691C53.6234 19.137 53.6052 19.3218 53.6407 19.5C53.6761 19.6783 53.7637 19.842 53.8922 19.9705C54.0207 20.099 54.1845 20.1865 54.363 20.222C54.5416 20.2575 54.7265 20.2393 54.8943 20.1698C55.0623 20.1003 55.2059 19.9824 55.307 19.8312C55.408 19.6801 55.4619 19.5025 55.4619 19.3207C55.4619 19.0771 55.365 18.8433 55.1926 18.671C55.0203 18.4986 54.7864 18.4018 54.5424 18.4018ZM53.1533 17.2421C53.5645 16.9674 54.0479 16.8207 54.5424 16.8207C55.2055 16.8207 55.8415 17.084 56.3104 17.5529C56.7794 18.0217 57.0429 18.6577 57.0429 19.3207C57.0429 19.8152 56.8962 20.2986 56.6214 20.7097C56.3467 21.1208 55.9562 21.4413 55.4992 21.6306C55.0422 21.8198 54.5395 21.8691 54.0547 21.7727C53.5698 21.6763 53.1242 21.4383 52.7744 21.0886C52.4247 20.739 52.1865 20.2935 52.09 19.8086C51.9936 19.3236 52.0431 18.8208 52.2324 18.3639C52.4217 17.907 52.7422 17.5167 53.1533 17.2421Z",
    fill: "#919EAB"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_2575_2852044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 49.2381H91.9998V79.3214C91.9998 83.6937 88.5887 87.2381 84.3808 87.2381H35.619C31.4112 87.2381 28 83.6937 28 79.3214V49.2381Z",
    fill: "#DFE3E8"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9048 39.3333C36.6247 39.3333 35.6191 40.3389 35.6191 41.6191C35.6191 42.8989 36.6247 43.9048 37.9048 43.9048C39.185 43.9048 40.1906 42.8989 40.1906 41.6191C40.1906 40.3389 39.185 39.3333 37.9048 39.3333Z",
    fill: "#DFE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1429 39.3333C43.8628 39.3333 42.8572 40.3389 42.8572 41.6191C42.8572 42.8989 43.8628 43.9048 45.1429 43.9048C46.4231 43.9048 47.4286 42.8989 47.4286 41.6191C47.4286 40.3389 46.4231 39.3333 45.1429 39.3333Z",
    fill: "#DFE3E8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.381 39.3333C51.1009 39.3333 50.0953 40.3389 50.0953 41.6191C50.0953 42.8989 51.1009 43.9048 52.381 43.9048C53.6612 43.9048 54.6667 42.8989 54.6667 41.6191C54.6667 40.3389 53.6612 39.3333 52.381 39.3333Z",
    fill: "#DFE3E8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_2575_2852044)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9998 40.0954V49.2381H28L28 40.0959C28 36.7294 30.7292 34 34.0957 34H85.9046C89.2709 34 91.9998 36.7291 91.9998 40.0954ZM37.9047 39.3333C36.6246 39.3333 35.619 40.3389 35.619 41.619C35.619 42.8989 36.6246 43.9047 37.9047 43.9047C39.1849 43.9047 40.1904 42.8989 40.1904 41.619C40.1904 40.3389 39.1849 39.3333 37.9047 39.3333ZM45.1428 39.3333C43.8627 39.3333 42.8571 40.3389 42.8571 41.619C42.8571 42.8989 43.8627 43.9047 45.1428 43.9047C46.423 43.9047 47.4285 42.8989 47.4285 41.619C47.4285 40.3389 46.423 39.3333 45.1428 39.3333ZM50.0952 41.619C50.0952 40.3389 51.1007 39.3333 52.3809 39.3333C53.661 39.3333 54.6666 40.3389 54.6666 41.619C54.6666 42.8989 53.661 43.9047 52.3809 43.9047C51.1007 43.9047 50.0952 42.8989 50.0952 41.619Z",
    fill: "#919EAB"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.3328 54.2363H65.6662C64.745 54.2363 63.9995 55.067 63.9995 56.0937V78.3825C63.9995 79.4091 64.745 80.2399 65.6662 80.2399H82.3328C83.2541 80.2399 83.9995 79.4091 83.9995 78.3825V56.0937C83.9995 55.067 83.2541 54.2363 82.3328 54.2363Z",
    fill: "#919EAB"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.6667 61.6659H44.3333C45.2546 61.6659 46 60.8351 46 59.8085C46 58.7818 45.2546 57.9511 44.3333 57.9511H37.6667C36.7454 57.9511 36 58.7818 36 59.8085C36 60.8351 36.7454 61.6659 37.6667 61.6659ZM36 67.2381C36 66.2114 36.7454 65.3807 37.6667 65.3807H54.3333C55.2546 65.3807 56 66.2114 56 67.2381C56 68.2647 55.2546 69.0955 54.3333 69.0955H37.6667C36.7454 69.0955 36 68.2647 36 67.2381ZM37.6667 72.8103C36.7454 72.8103 36 73.641 36 74.6677C36 75.6943 36.7454 76.5251 37.6667 76.5251H54.3333C55.2546 76.5251 56 75.6943 56 74.6677C56 73.641 55.2546 72.8103 54.3333 72.8103H37.6667Z",
    fill: "#919EAB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_2575_2852044",
    x: 20,
    y: 41.2381,
    width: 96,
    height: 70,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2575_2852044"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2575_2852044",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2575_2852044"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_2575_2852044",
    x: 20,
    y: 26,
    width: 96,
    height: 47.2381,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2575_2852044"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2575_2852044",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.388235 0 0 0 0 0.45098 0 0 0 0 0.505882 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2575_2852044"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcContent);
export default __webpack_public_path__ + "static/media/ic-content.232db1b64b2cd09f5e8ce775f2db4442.svg";
export { ForwardRef as ReactComponent };